module.exports = __webpack_public_path__ + "static/img/icon2_active.b4e0a59e.svg";